import { mobiClient } from '@/services/axiosConfig'
import { UnitListReq } from '../unit/types'
import { MNP75UnitRes } from './types'

export const getUnitList = async (req: UnitListReq): Promise<MNP75UnitRes | undefined> => {
  try {
    const headers = {
      isdn: req.isdn
    }
    const res = await mobiClient.get('/unit/mnp75', { headers })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
